<div class="settings-subtab-bar">
    <!-- <div class="container-fluid settings-tabs d-flex align-items-center">
        <div class="settings-subtabs d-flex align-items-center gap-4">
            <div class="settings-subtab-item" [class.active]="activeSettingsTab === 'general'"
                [routerLink]="['/home/settings']" (click)="activeSettingsTab = 'general'">
                General Settings
            </div>
            <div class="settings-subtab-item" [class.active]="activeSettingsTab === 'permission'"
                [routerLink]="['/home/permissions']" (click)="activeSettingsTab = 'permission'">
                Permission Settings
            </div>
        </div>
    </div> -->
    <!-- <section class="settings-subtabs-child">
        <div class="container-fluid">
            <div class="d-flex align-items-center gap-3">
                <div>
                    <p class="mb-0 active-tabs-name">{{activeSettingsTab}}</p>
                </div>
                <div class="settings-subtab-item-child" [class.active]="activeSettingsTab === 'general'"
                    [routerLink]="['/home/settings']" (click)="activeSettingsTab = 'general'">
                    General Settings
                </div>
                <div class="settings-subtab-item-child" [class.active]="activeSettingsTab === 'permission'"
                    [routerLink]="['/home/permissions']" (click)="activeSettingsTab = 'permission'">
                    Permission Settings
                </div>
            </div>
        </div>
    </section> -->
</div>
